import { Settings } from "./Settings";
import './index.scss';
export default Settings;